import Hero from '../components/Hero';
import TrendingModels from '../components/TrendingModels';
import ProviderTabs from '../components/ModelProviders/ProviderTabs';
import CodeTabs from '../components/CodeExamples/CodeTabs';
import CallToAction from '../components/CallToAction';
import Footer from '../components/Footer';

export default function Home() {
  return (
    <main>
      <div className="bg-gradient-to-b from-blue-50/50 via-gray-50 to-white">
        <Hero />
      </div>
      <div className="bg-gray-100">
        <TrendingModels />
      </div>
      <ProviderTabs />
      <CodeTabs />
      <CallToAction />
      <Footer />
    </main>
  );
}